interface PopupForSameOriginProps {
  win: Window;
  blackUrlList?: string[];
}

export default class FramePopupUtils {
  static isEmpty(str: string) {
    return typeof 'undefined' === str || !str || str.length === 0;
  }

  static openSizedPopup({
    urlNavigate,
    popupName = '',
    height = 483,
    width = 600,
  }: {
    urlNavigate: string;
    popupName?: string;
    height?: number;
    width?: number;
  }) {
    /**
     * adding winLeft and winTop to account for dual monitor
     * using screenLeft and screenTop for IE8 and earlier
     */
    const winLeft = window.screenLeft ? window.screenLeft : window.screenX;
    const winTop = window.screenTop ? window.screenTop : window.screenY;
    /**
     * window.innerWidth displays browser window"s height and width excluding toolbars
     * using document.documentElement.clientWidth for IE8 and earlier
     */
    const winWidth =
      window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
    const winHeight =
      window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;

    const top = Math.max(0, winHeight / 2 - height / 2 + winTop);
    const left = Math.max(0, winWidth / 2 - width / 2 + winLeft);

    const handle = window.open(
      urlNavigate,
      popupName,
      `width=${width}, height=${height}, top=${top}, left=${left}, scrollbars=no`,
    );

    handle?.blur();
    window.focus();

    return handle;
  }
}
